import { render, staticRenderFns } from "./editStatrgyArticleDialog.vue?vue&type=template&id=8dd1d914"
import script from "./editStatrgyArticleDialog.vue?vue&type=script&lang=js"
export * from "./editStatrgyArticleDialog.vue?vue&type=script&lang=js"
import style0 from "./editStatrgyArticleDialog.vue?vue&type=style&index=0&id=8dd1d914&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports